import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Switch from "react-switch";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const FlavorActions = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  //getting context values here
  let { loading, setLoading } = useContext(RestaurantContext);

  const toastObj = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  //item state
  const [newFlavor, setNewFlavor] = useState({
    name: "",
    short_code:"",
    status: 1,
  });

  //useEffect == componentDidMount()
  useEffect(() => {
    if (id) {
      getSpecificItem();
    }
  }, []);

  const getSpecificItem = async () => {
    setLoading(true);
    if (id) {
      const url =
        BASE_URL + "/settings/product-flavour/" + id;
      try {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if (res.data) {
          // console.log("check type data==>",res.data);
          const item = res.data;
          setNewFlavor({
            ...newFlavor,
            name: item.name,
            short_code: item.short_code,
            status: item.status
          })
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(`${_t(t("Please try again."))}`, toastObj);
      }
    }
  };

  const handleSetChange = (e) =>{
    setNewFlavor({
      ...newFlavor,
      [e.target.name] : e.target.value
    })
  }

  const handleStatus = ()=>{
    setNewFlavor({
      ...newFlavor,
      status : newFlavor.status === 1 ? 0 : 1,
    })
  }

  //post req of food item add
  const RegionItemAxios = async () => {
    setLoading(true);
    const endpoint = id ? `/settings/product-flavour/${id}` : "/settings/product-flavour";
    const url = BASE_URL + endpoint;
    let formData = {
      name: newFlavor.name,
      short_code: newFlavor.short_code,
      status: newFlavor.status,
    };
    try {
      const method= id ? "put" : "post";
      const res = await axios[method](url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res){
        toast.success(`${_t(t(id ? "Flavour has been updated" : "Flavour has been added"))}`, toastObj);
        setLoading(false);
        history.push("/dashboard/manage/food/flavor");
      }
    } catch (error) {
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, toastObj);
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (newFlavor.name) {
      RegionItemAxios();
    } else {
      toast.error(`${_t(t("Please Select All Fields"))}`, toastObj);
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t(id ? "Edit Flavor" : "Add Flavor"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading} />
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {id
                                  ? _t(t("Edit Flavor"))
                                  : _t(t("Add Flavor"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <form
                        className="row card p-2 mx-3 mb-5 table-text"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                      >
                        <div className="col-12">
                          <div className="row">
                            <div className="form-group col-6 mt-2">
                              <div className="mb-2 ">
                                <label
                                  htmlFor="name"
                                  className="control-label"
                                >
                                  {_t(t("Name"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="name"
                                  name="name"
                                  placeholder="e.g. bbq"
                                  value={newFlavor.name || ""}
                                  required
                                  onChange={handleSetChange}
                                />
                              </div>
                            </div>

                            <div className="form-group col-6 mt-2">
                              <div className="mb-2 ">
                                <label
                                  htmlFor="short_code"
                                  className="control-label"
                                >
                                  {_t(t("Short Name"))}
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="short_code"
                                  name="short_code"
                                  placeholder="e.g. bbq"
                                  value={newFlavor.short_code || ""}
                                  onChange={handleSetChange}
                                />
                              </div>
                            </div>

                            <div className="form-group mt-2 col-6">
                              <label htmlFor="status" className="form-label mb-2">
                              {_t(t("Status"))}{" "}
                              </label>
                              <div className="mt-1 ml-1">
                                <Switch
                                  onChange={handleStatus}
                                  checked={newFlavor.status === 1}
                                  className="react-switch ml-1"
                                  name="status"
                                  height={20}
                                  width={42}
                                  offColor="#ee5253"                        
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group mt-4 pb-2">
                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/food/flavor"
                                    )
                                  }
                                >
                                  <i
                                    className="fa fa-arrow-left"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i
                                    className="fa fa-floppy-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Save"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default FlavorActions;
